import Vue from 'vue'
import VueRouter from 'vue-router'
import "@/js/lib/ui-bundles.js"
import Main from '@/components/main'
import Utils from '@/js/sageflo/utils.js'
import MainStore from '@/store/main.js'
import routes from '@/router/main.js'
import '@/css/app.css'

Vue.prototype.$eventBus = new Vue() // makes event bus available to all Vue app and components

Vue.use(VueRouter)
const router = new VueRouter({
  routes
});
import 'whatwg-fetch'
var vue = null;
Utils.checkLoggedIn()
.then ((loggedIn)=>{
  if (loggedIn){
    vue = new Vue({
      el: '#app',
      router,
      store: MainStore,
      render: h => h(Main),
    });
  }
});
